import { useState, useEffect } from 'react';
import { getItemListId } from '../helpers';
const useItemListId = ({
  listName
}) => {
  const idFromStorage = getItemListId(listName);
  const [listId, setListId] = useState(idFromStorage);
  useEffect(() => {
    const storageEventHandler = () => {
      const newId = getItemListId(listName);
      setListId(newId);
    };
    window.addEventListener('storage', storageEventHandler);
    return () => {
      window.removeEventListener('storage', storageEventHandler);
    };
  }, [listName]);
  return {
    listId
  };
};
export default useItemListId;
//# sourceMappingURL=use-item-list-id.js.map